import styled from 'styled-components'

export const TableWrapper = styled.div`
  position: relative;
`

export const TableMeta = styled.div`
  flex-direction: column;
  position: absolute;
  top: 19px;
  left: 8px;
  padding: 0;
  @media (max-width: 900px) {
    position: unset;
  }
`

export const TableActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 767.98px) {
    flex-direction: column;
    gap: 24px;
  }
`

export const TableActionsRight = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export const IconCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`
